"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ng2_overlay_1 = require("ng2-overlay");
var Ng2TooltipComponent = (function () {
    function Ng2TooltipComponent(viewContainerRef, ng2OverlayManager) {
        this.viewContainerRef = viewContainerRef;
        this.ng2OverlayManager = ng2OverlayManager;
        this.el = this.viewContainerRef.element.nativeElement;
    }
    Ng2TooltipComponent.prototype.ngAfterViewInit = function () {
        this.ng2Overlay = this.getTooltipOverlay(this.el, this.tooltip);
    };
    Ng2TooltipComponent.prototype.showTooltip = function ($event) {
        this.ng2OverlayManager.open(this.ng2Overlay, $event);
        $event.stopPropagation();
    };
    Ng2TooltipComponent.prototype.hideTooltip = function ($event) {
        this.ng2OverlayManager.close(this.ng2Overlay);
        $event.stopPropagation();
    };
    Ng2TooltipComponent.prototype.getTooltipOverlay = function (el, tooltip) {
        var tooltipEl = document.createElement('ng2-tooltip');
        tooltipEl.style.display = 'none';
        var divEl = document.createElement('div');
        divEl.innerHTML = "\n       <div class='tooltip-contents'>" + tooltip + "</div>\n       <div class='tooltip-down-arrow'></div>\n    ";
        tooltipEl.appendChild(divEl);
        //el.parentElement.insertBefore(tooltipEl, el.nextSibling);
        el.appendChild(tooltipEl);
        var ng2Overlay = new ng2_overlay_1.Ng2Overlay(tooltipEl, {
            id: 'tooltip-' + (el.id || Math.floor(Math.random() * 1000000)),
            position: 'top cursor outside'
        });
        this.ng2OverlayManager.register(ng2Overlay);
        return ng2Overlay;
    };
    return Ng2TooltipComponent;
}());
__decorate([
    core_1.Input('ng2-tooltip'),
    __metadata("design:type", String)
], Ng2TooltipComponent.prototype, "tooltip", void 0);
Ng2TooltipComponent = __decorate([
    core_1.Component({
        selector: '[ng2-tooltip]',
        template: '<ng-content></ng-content>',
        host: {
            '(mouseover)': 'showTooltip($event)',
            '(mouseout)': 'hideTooltip($event)'
        },
        styles: ["\n    ng2-tooltip .tooltip-contents {\n      border: 1px solid #ccc; padding: 5px\n    }\n    ng2-tooltip .tooltip-down-arrow {\n      height: 10px;\n    }\n    ng2-tooltip .tooltip-down-arrow:before {\n      content: '';\n      display: block;\n      position: absolute;\n      width: 10px;\n      height: 10px;\n      left: 45%;\n      bottom: 5px;\n      background: #FFFFFF;\n      border-left:1px solid #ccc;\n      border-bottom:1px solid #ccc;\n      transform:rotate(-45deg);\n    }\n  "],
        encapsulation: core_1.ViewEncapsulation.None
    }),
    __metadata("design:paramtypes", [core_1.ViewContainerRef,
        ng2_overlay_1.Ng2OverlayManager])
], Ng2TooltipComponent);
exports.Ng2TooltipComponent = Ng2TooltipComponent;
//# sourceMappingURL=ng2-tooltip-component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-tooltip-overlay/dist/ng2-tooltip-component.js
// module id = 56
// module chunks = 0